import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Community from "@/pages/Community";
import Login from "@/pages/Login";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import POC from "@/pages/POC";
import AdminLayout from "@/components/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminLibrary from "@/pages/admin/Library";
import AdminComposer from "@/pages/admin/Composer";
import AdminCalendar from "@/pages/admin/Calendar";
import AdminSkoolPlaybook from "@/pages/admin/SkoolPlaybook";
import AdminMonetization from "@/pages/admin/Monetization";
import AdminLaunchKit from "@/pages/admin/LaunchKit";
import AdminSettings from "@/pages/admin/Settings";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:category" element={<Shop />} />
          <Route path="/shop/product/:slug" element={<ProductDetail />} />
          <Route path="/community" element={<Community />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/checkout/cancel" element={<CheckoutCancel />} />
          <Route path="/login" element={<Login />} />
          <Route path="/poc" element={<POC />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="library" element={<AdminLibrary />} />
            <Route path="composer" element={<AdminComposer />} />
            <Route path="calendar" element={<AdminCalendar />} />
            <Route path="skool-playbook" element={<AdminSkoolPlaybook />} />
            <Route path="monetization" element={<AdminMonetization />} />
            <Route path="launch-kit" element={<AdminLaunchKit />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
